<template>
  <div class="tg-toolbar--title">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>